import { render, staticRenderFns } from "./Promotor.vue?vue&type=template&id=54e7db80&scoped=true&"
import script from "./Promotor.vue?vue&type=script&lang=js&"
export * from "./Promotor.vue?vue&type=script&lang=js&"
import style0 from "./Promotor.vue?vue&type=style&index=0&id=54e7db80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e7db80",
  null
  
)

export default component.exports